<!-- Loading -->
<ng-container *ngIf="!ready">
  <div class="rsv-loading">
    <div class="rsv-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap">
        <mat-icon>account_balance</mat-icon>
      </div>
      <div>
        <span>{{ uid ? 'Editar reserva' : 'Nueva reserva' }}</span>
        <small class="dlg-hdr__sub" *ngIf="flagImport">Importación: {{ movement?.reference }}</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && !uid">Añade un movimiento de reserva</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && uid">Modifica el importe o el tipo</small>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="rsv-body">

    <!-- Importación banner -->
    <div class="rsv-import-banner" *ngIf="flagImport">
      <mat-icon>file_download</mat-icon>
      <div>
        <span class="rsv-import-banner__label">Título de importación</span>
        <span class="rsv-import-banner__value">{{ movement?.reference }}</span>
      </div>
    </div>

    <div class="row g-3">

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Importe</mat-label>
          <mat-icon matPrefix>attach_money</mat-icon>
          <input type="number" matInput [formControl]="amountFormControl" placeholder="0.00">
          <span matSuffix class="rsv-suffix">€</span>
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de reserva</mat-label>
          <mat-icon matPrefix>label</mat-icon>
          <mat-select [(ngModel)]="reserveModel.reserveTypeId" [formControl]="reserveTypeFormControl">
            <mat-option disabled value=""><em>Seleccionar tipo</em></mat-option>
            <mat-option *ngFor="let t of reserveTypeModel" [value]="t.id">{{ t.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dlg-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="rsv-btn-save" type="button" (click)="onSubmit()" [disabled]="submitted">
      <mat-icon>save</mat-icon>
      {{ uid ? 'Guardar cambios' : 'Crear reserva' }}
    </button>
  </mat-dialog-actions>

</ng-container>
